module.exports = __webpack_public_path__ + "img/df2847e.png";